<template>
  <section class="blaFifthSection">
    <div class="row pa-2">
      <div class="col-10 offset-1 col-md-8 offset-md-2">
        <div class="row">
          <div class="col-12 text-center justify-center">
            <div v-if="title !== null" class="blaFifthSectionTitle">
              {{ title }}
            </div>

            <div class="row">
              <div class="col-10 offset-1 col-md-8 offset-md-2">
                <div
                  v-if="description !== null"
                  class="blaFifthSectionDescription"
                  v-html="description"
                ></div>
              </div>
            </div>

            <div
              v-if="button_url !== null && button_title !== null"
              class="clickable mt-3 blaPrimaryButton text-center py-3 justify-center pl-50"
              @click="goToUrl(button_url)"
            >
              <span v-if="button_title !== null" class="px-3 py-3">
                {{ button_title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  methods: {
    goToUrl(url) {
      window.location.href = url;
    },
  },
  props: {
    title: String,
    description: String,
    button_title: String,
    button_url: String,
  },
  mounted: () => ({}),
};
</script>
